/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React from 'react';

// material-ui
import { useTheme } from '@material-ui/core/styles';
import {
  Card, CardContent, CardHeader, Divider, Typography,
  useMediaQuery,
} from '@material-ui/core';

// -----------------------|| CUSTOM MAIN CARD ||-----------------------//

const MainCard = React.forwardRef(
  (
    {
      border = true,
      boxShadow,
      children,
      content = true,
      contentClass,
      contentSX,
      darkTitle,
      secondary,
      shadow,
      sx = {},
      title,
      subheader,
      ...others
    },
    ref,
  ) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const headerSX = {
      '& .MuiCardHeader-action': { mr: 0, width: isMobile ? '100%' : undefined },
    };

    return (
      <Card
        ref={ref}
        {...others}
        sx={{
          border: border ? '1px solid' : 'none',
          borderColor: theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.primary[200] + 75,
          ':hover': {
            boxShadow: boxShadow
              ? shadow || (theme.palette.mode === 'dark'
                ? '0 2px 14px 0 rgb(33 150 243 / 10%)'
                : '0 2px 14px 0 rgb(32 40 45 / 8%)')
              : 'inherit',
          },
          flexDirection: isMobile ? 'column' : 'row',
          ...sx,
        }}
      >
        {/* card header and action */}
        {!darkTitle && title && (
          <CardHeader
            sx={isMobile ? {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              ...headerSX,
            } : { ...headerSX }}
            title={title}
            subheader={subheader}
            action={secondary}
          />
        )}
        {darkTitle && title && (
          <CardHeader
            sx={isMobile ? {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              ...headerSX,
            } : { ...headerSX }}
            title={<Typography variant="h3">{title}</Typography>}
            subheader={subheader}
            action={secondary}
          />
        )}

        {/* content & header divider */}
        {title && <Divider />}

        {/* card content */}
        {content && (
          <CardContent sx={contentSX} className={contentClass}>
            {children}
          </CardContent>
        )}
        {!content && children}
      </Card>
    );
  },
);

MainCard.propTypes = {
  border: PropTypes.bool,
  boxShadow: PropTypes.bool,
  children: PropTypes.node,
  content: PropTypes.bool,
  contentClass: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  contentSX: PropTypes.object,
  darkTitle: PropTypes.bool,
  secondary: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object]),
  shadow: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  sx: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object]),
  subheader: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object]),
};

export default MainCard;
